import moment from 'moment';

export const extractDate = utc => {
  const out = moment(utc);
  return out.isValid() ? out.format('DD/MM/YYYY') : null;
};

export const extractLongDate = utc => {
  const out = moment(utc, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
  return out.isValid() ? out.format('DD/MM/YYYY hh:mm') : null;
};

export const extractCompleteDate = utc => {
  const out = moment(utc);
  return out.isValid() ? out.format('DD/MM/YYYY h:mm:ss') : null;
};
